import { Text } from "@ecco/ui/text";
import { Skeleton } from "@ecco/ui/skeleton";
import { Flex } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import type { FC, ReactNode } from "react";

export interface DeliveryEstimateLabelProps {
    label: ReactNode | null;
    isLoading?: boolean;
}

// Shared by DeliveryMethods and RadioButtonPickUpPoint. The skeleton reserves the row's space
// during the fetch so the label doesn't pop in and shift the layout (CLS) once it resolves.
export const DeliveryEstimate: FC<DeliveryEstimateLabelProps> = ({ label, isLoading = false }) => {
    if (!isLoading && !label) return null;

    return (
        <Flex gap={1} alignItems="center" minHeight="18px">
            {isLoading ? (
                <Skeleton width="120px" height="14px" />
            ) : (
                <>
                    <ECCOIcon name="delivery-package" size="xs" color="black" />
                    <Text size="small">{label}</Text>
                </>
            )}
        </Flex>
    );
};
